import classNames from "classnames";
import React from "react";
import { withRouter } from "react-router-dom";
import { Dropdown } from "rsuite";
import {
  getEnumDescription,
  ProfileApplication,
} from "../../core/enums/Profiles";
import { MethodsUtils } from "../../core/utils/MethodsUtils";
import axios from "../../utilities/axios";
import { isInPath } from "../../utilities/isInPath";
import { AuthContext, ModuleContext, UserContext } from "../authProvider/main";
import { BreadCrumbs } from "../breadcrumbs/main";
import { ModuleShortcuts } from "./moduleShortcut";

let isDesenv = false;
class InnerTopbar extends React.Component<
  any,
  { currentCompany: string | null; ambient: any }
> {
  public state = {
    currentCompany: localStorage.getItem("currentCompany"),
    ambient: "",
  };

  logout = () => {
    this.props.auth.setAuth(null);
    localStorage.removeItem("currentCompany");
    localStorage.removeItem("token")
    this.props.history.push("/login");
    window.location.reload()
  };

  goBack = () => {
    this.props.history.push("/dashboard");
  };

  onModuleClick = (moduleName: string) => {
    if (moduleName === "dashboard") {
      this.props.history.push("/dashboard");
      return;
    }
    this.props.history.push("/dashboard/" + moduleName);
  };

  async verify(): Promise<void> {
    try {
      const res = await axios.get("/api/v1/myprof");
      if (res.data) {
        if (res.data.database.includes("-desenv") || res.data.database.includes("_homolog") || res.data.database.includes("_local")) {
          isDesenv = true;
        }

        // if (isDesenv) {
        //   if (res.data.database.includes("-desenv")) {
        //     const ambient: any = getEnumDescription(ProfileApplication.DESENVOLVIMENTO);
        //     this.setState({ ambient }, () => this.forceUpdate());
        //   } else if (res.data.database.includes("_homolog")) {
        //     const ambient: any = getEnumDescription(ProfileApplication.HOMOLOG);
        //     this.setState({ ambient }, () => this.forceUpdate());
        //   } else if (res.data.database.includes("_local")) {
        //     const ambient: any = getEnumDescription(ProfileApplication.LOCAL);
        //     this.setState({ ambient }, () => this.forceUpdate());
        //   }
        // }

        const ambient: any = getEnumDescription(ProfileApplication.PROD);
        this.setState({ ambient }, () => this.forceUpdate());
      }

    } catch (error) {
      console.error("Erro ao verificar o perfil:", error);
    }
  }

  async componentDidMount() {
    await this.verify();
  }

  renderProfileButton() {
    const { ambient } = this.state;

    if (this.props.user.data) {
      return (
        <div
          // onClick={this.goBack}
          className="clickable"
          style={{
            textTransform: "capitalize",
            fontSize: 12,
            fontWeight: "bold",
          }}
        >
          <div
            className="logged"
            style={{
              width: '100%',
              marginRight: 10
            }}
          >
            <span style={{ color: this.props.location.pathname === '/dashboard' ? "black" : "#ffffff" }}>
              {`${MethodsUtils.formatName(this.props.user.data.user_name)} - ${this.props.user.data.role.role_name}`}
            </span>

          </div>
        </div>
      );
    } else {
      return null;
    }
  }

  // Função que renderiza o botão de módulos
  renderModulesButton() {
    return (
      <div
        onClick={this.goBack}
        className="clickable"
        style={{
          textTransform: "capitalize",
          fontSize: 18,
          fontWeight: "bold",
          minWidth: 200,
          textAlign: "right",
        }}
      >
        <i className="fas fa-fw fa-th-large mr-2"></i>
        {this.props.module.name
          ? this.props.module.name.split("-").join(" ")
          : ""}
      </div>
    );
  }

  // Função que seleciona a empresa atual e atualiza o estado
  onSelectCompany(id: any) {
    localStorage.setItem("currentCompany", id);
    this.setState({ currentCompany: id });
    this.props.history.push("/dashboard");
  }

  render() {
    // Verifica se o token de autenticação ou o nome do módulo não existem
    if (!this.props.auth.token && !this.props.module.name) {
      return null;
    }

    return (
      <div
        className={classNames("topbar", this.props.fulld ? "topbar-fulld" : this.props.full ? "topbar-full" : "")}
        style={{ backgroundColor: this.props.module.color }}
      >
        {/* renderiza os botões dos módulos no top bar */}
        <div style={{ width: "40%", display: "flex", alignItems: "center" }}>
          {this.props.location.pathname.includes("configuracoes") && (
            <i
              onClick={() => this.props.changeSidebar()}
              className={"fas fa-bars"}
            ></i>
          )}
          <BreadCrumbs />
        </div>

        {!isInPath(this.props.location.pathname, "/dashboard") && (
          <ModuleShortcuts onClick={this.onModuleClick} />
        )}

        <div
          style={{
            width: "10dvw;",
            textAlign: "right",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <Dropdown
            placement="bottomEnd"
            title={this.renderProfileButton()}
            className="custom-dropdown"
          >
            <Dropdown.Item
              onSelect={() =>
                this.props.history.push("/dashboard/configuracoes/profile")
              }
              className="custom-dropdown-item"
            >
              <i className="fas fa-fw fa-user icon"></i> Meu perfil
            </Dropdown.Item>
            <Dropdown.Item
              onSelect={this.logout}
              className="custom-dropdown-item"
            >
              <i className="fas fa-fw fa-sign-out-alt icon"></i> Logout
            </Dropdown.Item>
          </Dropdown>
        </div>
      </div>
    );
  }
}

class Topbar extends React.Component<any, {}> {
  render() {

    return (
      <ModuleContext.Consumer>
        {(moduleContext) => {
          return (
            <AuthContext.Consumer>
              {(auth) => {
                let moduleVar: any = moduleContext;
                if (isInPath(this.props.location.pathname, "/dashboard")) {
                  moduleVar = { name: "", setModule: () => { } };
                }
                return (
                  <UserContext.Consumer>
                    {(user: any) => {
                      if (user.data?.user_name) {
                        return (
                          <InnerTopbar
                            changeSidebar={() => this.props.changeSidebar()}
                            fulld={
                              isInPath(this.props.location.pathname, "/dashboard")
                            }
                            full={
                              isInPath(this.props.location.pathname, "/dashboard/import") ? true : this.props.hiddenSidebar
                            }
                            location={this.props.location}
                            history={this.props.history}
                            module={moduleVar}
                            auth={auth}
                            user={user}
                          />
                        );
                      } else {
                        return <></>;
                      }
                    }}
                  </UserContext.Consumer>
                );
              }}
            </AuthContext.Consumer>
          );
        }}
      </ModuleContext.Consumer>
    );
  }
}

export default withRouter(Topbar);
